import { render } from "./DataGenerator.vue?vue&type=template&id=1aa6fdc4&scoped=true"
import script from "./DataGenerator.vue?vue&type=script&lang=js"
export * from "./DataGenerator.vue?vue&type=script&lang=js"

import "./DataGenerator.vue?vue&type=style&index=0&id=1aa6fdc4&scoped=true&lang=css"

import exportComponent from "/var/www/testback/Frontend/sdd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa6fdc4"]])

export default __exports__
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDate});
